import { FilterXIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * The toolbar's "reset the filters", which only means something once a filter is on.
 *
 * Always there, and disabled while there is nothing to reset. Popping in the moment a box was
 * ticked shoved everything after it sideways — and on a narrow screen onto the next line — right
 * where the pointer was; holding an invisible place for it left a hole in the toolbar instead. A
 * quiet, greyed-out control is neither: it says where the reset will be and that there is nothing
 * to reset yet.
 */
export function ClearFiltersButton({
  active,
  label,
  onClick,
}: {
  /** Whether any filter is narrowing the list. */
  active: boolean
  label: string
  onClick: () => void
}) {
  return (
    <Button variant="ghost" size="sm" disabled={!active} onClick={onClick}>
      <FilterXIcon />
      {/* Icon alone on a phone, where the words pushed the reload button onto a line of its
          own. */}
      <span className="max-md:sr-only">{label}</span>
    </Button>
  )
}
